"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDefaultOrder = void 0;
function buildDefaultOrder(defaultField, defaultDirections) {
    return {
        field: defaultField,
        direction: defaultDirections[defaultField],
    };
}
exports.buildDefaultOrder = buildDefaultOrder;
//# sourceMappingURL=SortProviderProps.js.map